module.exports = __webpack_public_path__ + "static/phone_cropped.274f95a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/images/phone_cropped.svg
// module id = 776
// module chunks = 35783957827783